import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import OrdiniPage from "@/pages/OrdiniPage";
import CassaPage from "@/pages/CassaPage";
import AdvPage from "@/pages/AdvPage";
import QuoteSociPage from "@/pages/QuoteSociPage";
import ProdottiPage from "@/pages/ProdottiPage";
import DatiMancantiPage from "@/pages/DatiMancantiPage";
import DivergenzePage from "@/pages/DivergenzePage";
import ImportPage from "@/pages/ImportPage";
import ConfigurazionePage from "@/pages/ConfigurazionePage";
import LogPage from "@/pages/LogPage";

function Protected() {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm">Caricamento…</div>;
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout />;
}

function MasterOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "master") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route element={<Protected />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/ordini" element={<OrdiniPage />} />
            <Route path="/cassa" element={<CassaPage />} />
            <Route path="/adv" element={<MasterOnly><AdvPage /></MasterOnly>} />
            <Route path="/quote-soci" element={<QuoteSociPage />} />
            <Route path="/prodotti" element={<MasterOnly><ProdottiPage /></MasterOnly>} />
            <Route path="/dati-mancanti" element={<MasterOnly><DatiMancantiPage /></MasterOnly>} />
            <Route path="/divergenze" element={<MasterOnly><DivergenzePage /></MasterOnly>} />
            <Route path="/import" element={<MasterOnly><ImportPage /></MasterOnly>} />
            <Route path="/configurazione" element={<MasterOnly><ConfigurazionePage /></MasterOnly>} />
            <Route path="/log" element={<MasterOnly><LogPage /></MasterOnly>} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
